import { getStaticPathsForLocales } from '../../../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { NewBookingPaymentPage } from '../../../../../features/parking/ui/booking-pages/new-booking/NewBookingPaymentPage';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps = () => ({ props: {} });

export default NewBookingPaymentPage;
